// extracted by mini-css-extract-plugin
export default {"main__header":"Header_main__header__q+qYM","header":"Header_header__Q2d9d"};